module.exports = __webpack_public_path__ + "static/media/bonus_spine_sfx.3df31006.ogg";